export default __webpack_public_path__ + "static/media/858_1.48f579a3.jpg";